import type { Config } from "tailwindcss";
import tailwindAnimate from "tailwindcss-animate";
import tailwindScrollbar from "tailwind-scrollbar";
import tailwindTypography from "@tailwindcss/typography";

const backgroundColors = {
    error: "var(--color-background-danger-subtle-default)",
    "input-default": "var(--color-background-input-default)",
    "selected-default": "var(--color-background-selected-default)",
    "selected-hover": "var(--color-background-selected-hover)",
    "selected-press": "var(--color-background-selected-press)",
    "neutral-default": "var(--color-background-neutral-default)",
    "neutral-hover": "var(--color-background-neutral-hover)",
    "neutral-press": "var(--color-background-neutral-press)",
    "neutral-subtlest-default":
        "var(--color-background-neutral-subtlest-default)",
    "neutral-subtlest-hover": "var(--color-background-neutral-subtlest-hover)",
    "neutral-subtlest-press": "var(--color-background-neutral-subtlest-press)",
    "neutral-subtle-default": "var(--color-background-neutral-subtle-default)",
    "neutral-subtle-hover": "var(--color-background-neutral-subtle-hover)",
    "neutral-subtle-press": "var(--color-background-neutral-subtle-press)",
    "neutral-bold-default": "var(--color-background-neutral-bold-default)",
    "neutral-bold-hover": "var(--color-background-neutral-bold-hover)",
    "neutral-bold-press": "var(--color-background-neutral-bold-press)",
    "brand-primary-default": "var(--color-background-brand-primary-default)",
    "brand-primary-hover": "var(--color-background-brand-primary-hover)",
    "brand-primary-press": "var(--color-background-brand-primary-press)",
    "brand-secondary-default":
        "var(--color-background-brand-secondary-default)",
    "brand-secondary-hover": "var(--color-background-brand-secondary-hover)",
    "brand-secondary-press": "var(--color-background-brand-secondary-press)",
    "icon-accent-blue": "var(--color-icon-accent-blue)",
    "input-hover": "var(--color-background-input-hover)",
    "brand-bold-primary-default":
        "var(--color-background-brand-bold-primary-default)",
    "brand-bold-secondary-default":
        "var(--color-background-brand-bold-secondary-default)",
    "brand-bold-secondary-hover":
        "var(--color-background-brand-bold-secondary-hover)",
    "brand-bold-secondary-press":
        "var(--color-background-brand-bold-secondary-press)",
    "brand-bold-primary-press":
        "var(--color-background-brand-bold-primary-press)",
    "input-press": "var(--color-background-input-press)",
    "brand-bold-primary-hover":
        "var(--color-background-brand-bold-primary-hover)",
    "icon-accent-purple": "var(--color-icon-accent-purple)",
    "information-subtle-default":
        "var(--color-background-information-subtle-default)",
    "information-subtle-hover":
        "var(--color-background-information-subtle-hover)",
    "information-subtle-press":
        "var(--color-background-information-subtle-press)",
    "input-disabled": "var(--color-background-input-disabled)",
    "information-bold-default":
        "var(--color-background-information-bold-default)",
    "information-bold-hover": "var(--color-background-information-bold-hover)",
    "information-bold-press": "var(--color-background-information-bold-press)",
    "success-default": "var(--color-background-success-default)",
    "success-hover": "var(--color-background-success-hover)",
    "success-press": "var(--color-background-success-press)",
    "success-subtle-default": "var(--color-background-success-subtle-default)",
    "success-subtle-hover": "var(--color-background-success-subtle-hover)",
    "success-subtle-press": "var(--color-background-success-subtle-press)",
    "success-bold-default": "var(--color-background-success-bold-default)",
    "success-bold-hover": "var(--color-background-success-bold-hover)",
    "success-bold-press": "var(--color-background-success-bold-press)",
    "warning-default": "var(--color-background-warning-default)",
    "warning-hover": "var(--color-background-warning-hover)",
    "warning-press": "var(--color-background-warning-press)",
    "warning-subtle-default": "var(--color-background-warning-subtle-default)",
    "warning-subtle-hover": "var(--color-background-warning-subtle-hover)",
    "warning-subtle-press": "var(--color-background-warning-subtle-press)",
    "warning-bold-default": "var(--color-background-warning-bold-default)",
    "warning-bold-hover": "var(--color-background-warning-bold-hover)",
    "warning-bold-press": "var(--color-background-warning-bold-press)",
    "danger-default": "var(--color-background-danger-default)",
    "danger-hover": "var(--color-background-danger-hover)",
    "danger-press": "var(--color-background-danger-press)",
    "danger-subtle-default": "var(--color-background-danger-subtle-default)",
    "danger-subtle-hover": "var(--color-background-danger-subtle-hover)",
    "danger-subtle-press": "var(--color-background-danger-subtle-press)",
    "danger-bold-default": "var(--color-background-danger-bold-default)",
    "danger-bold-hover": "var(--color-background-danger-bold-hover)",
    "danger-bold-press": "var(--color-background-danger-bold-press)",
    "announcement-default": "var(--color-background-announcement-default)",
    "announcement-hover": "var(--color-background-announcement-hover)",
    "announcement-press": "var(--color-background-announcement-press)",
    "announcement-subtle-default":
        "var(--color-background-announcement-subtle-default)",
    "announcement-subtle-hover":
        "var(--color-background-announcement-subtle-hover)",
    "announcement-subtle-press":
        "var(--color-background-announcement-subtle-press)",
    "announcement-bold-default":
        "var(--color-background-announcement-bold-default)",
    "announcement-bold-hover":
        "var(--color-background-announcement-bold-hover)",
    "announcement-bold-press":
        "var(--color-background-announcement-bold-press)",
    "information-default": "var(--color-background-information-default)",
    "data-categorical-1-area": "var(--color-data-categorical-1-area)",
    "accent-red-subtle": "var(--color-background-accent-red-subtle)",
    "accent-red-default": "var(--color-background-accent-red-default)",
    "accent-red-bold": "var(--color-background-accent-red-bold)",
    "accent-orange-subtle": "var(--color-background-accent-orange-subtle)",
    "accent-orange-default": "var(--color-background-accent-orange-default)",
    "accent-orange-bold": "var(--color-background-accent-orange-bold)",
    "information-hover": "var(--color-background-information-hover)",
    "information-press": "var(--color-background-information-press)",
    "accent-yellow-subtle": "var(--color-background-accent-yellow-subtle)",
    "accent-yellow-default": "var(--color-background-accent-yellow-default)",
    "accent-yellow-bold": "var(--color-background-accent-yellow-bold)",
    "accent-green-subtle": "var(--color-background-accent-green-subtle)",
    "accent-green-default": "var(--color-background-accent-green-default)",
    "accent-green-bold": "var(--color-background-accent-green-bold)",
    "accent-blue-subtle": "var(--color-background-accent-blue-subtle)",
    "accent-blue-default": "var(--color-background-accent-blue-default)",
    "accent-blue-bold": "var(--color-background-accent-blue-bold)",
    "accent-purple-subtle": "var(--color-background-accent-purple-subtle)",
    "accent-purple-default": "var(--color-background-accent-purple-default)",
    "accent-purple-bold": "var(--color-background-accent-purple-bold)",
    "accent-magenta-subtle": "var(--color-background-accent-magenta-subtle)",
    "accent-magenta-default": "var(--color-background-accent-magenta-default)",
    "accent-magenta-bold": "var(--color-background-accent-magenta-bold)",
    "accent-teal-subtle": "var(--color-background-accent-teal-subtle)",
    "accent-teal-default": "var(--color-background-accent-teal-default)",
    "accent-teal-bold": "var(--color-background-accent-teal-bold)",
    "accent-grey-subtle": "var(--color-background-accent-grey-subtle)",
    "accent-grey-default": "var(--color-background-accent-grey-default)",
    "accent-grey-bold": "var(--color-background-accent-grey-bold)",
    "elevation-surface-default": "var(--elevation-surface-default)",
    "elevation-surface-sunken-default":
        "var(--elevation-surface-sunken-default)",
    "elevation-surface-sunken-hover": "var(--elevation-surface-sunken-hover)",
    "elevation-surface-sunken-press": "var(--elevation-surface-sunken-press)",
    "elevation-surface-raised-default":
        "var(--elevation-surface-raised-default)",
    "elevation-surface-raised-hover": "var(--elevation-surface-raised-hover)",
    "elevation-surface-raised-press": "var(--elevation-surface-raised-press)",
    "elevation-surface-hover": "var(--elevation-surface-hover)",
    "elevation-surface-overlay-default":
        "var(--elevation-surface-overlay-default)",
    "elevation-surface-overlay-hover": "var(--elevation-surface-overlay-hover)",
    "elevation-surface-press": "var(--elevation-surface-press)",
    "elevation-surface-overlay-press": "var(--elevation-surface-overlay-press)",
    "blanket-default": "var(--color-blanket-default)",
    "blanket-subtle": "var(--color-blanket-subtle)",
    // start shadcn
    background: "hsl(var(--background))",
    transparent: "transparent",

    // end shadcn
};

const config = {
    darkMode: "class",
    important: true, // Kill this once dx global styles are dead
    content: ["./index.html", "./src/**/*.{ts,tsx,js,jsx}"],
    // Everything in `theme` that's not in `extends` overwrites classes in tailwind;
    // this is destructive, meaning the default's from tailwind are no longer available.
    theme: {
        borderRadius: {
            full: "var(--corner-radius-full)",
            default: "var(--corner-radius-default)",
            narrow: "var(--corner-radius-narrow)",
        },
        fontSize: {
            smallest: "var(--font-size-smallest)",
            small: "var(--font-size-small)",
            default: "var(--font-size-default)",
            large: "var(--font-size-large)",
            larger: "var(--font-size-larger)",
            largest: "var(--font-size-largest)",
            giant: "var(--font-size-giant)",
            enormous: "var(--font-size-enormous)",
        },
        lineHeight: {
            none: "1",
            smallest: "var(--line-height-smallest)",
            smaller: "var(--line-height-smaller)",
            small: "var(--line-height-small)",
            default: "var(--line-height-default)",
            large: "var(--line-height-large)",
            larger: "var(--line-height-larger)",
            largest: "var(--line-height-largest)",
        },
        fontWeight: {
            default: "var(--font-weight-default)",
            bold: "var(--font-weight-bold)",
            bolder: "var(--font-weight-bolder)",
            boldest: "var(--font-weight-boldest)",
        },
        fontFamily: {
            heading: "var(--font-family-heading)",
            body: "var(--font-family-body)",
            code: "var(--font-family-code)",
        },
        letterSpacing: {
            default: "-0.1px",
            tight: "-0.144px",
            tighter: "-0.24px",
            tightest: "-0.48px",
        },
        textColor: {
            inherit: "inherit",
            current: "currentColor",
            transparent: "transparent",
            "default-color": "var(--color-text-default)", // Odd name is to prevent conflict
            subtle: "var(--color-text-subtle)",
            subtler: "var(--color-text-subtler)",
            subtlest: "var(--color-text-subtlest)",
            inverse: "var(--color-text-inverse)",
            "inverse-subtle": "var(--color-text-inverse-subtle)",
            selected: "var(--color-text-selected)",
            disabled: "var(--color-text-disabled)",
            brand: "var(--color-text-brand)",
            success: "var(--color-text-success)",
            warning: "var(--color-text-warning)",
            danger: "var(--color-text-danger)",
            announcement: "var(--color-text-announcement)",
            information: "var(--color-text-information)",
            "link-default": "var(--color-link-default)",
            "link-hover": "var(--color-link-hover)",
            "link-press": "var(--color-link-press)",
            "link-visited-default": "var(--color-link-visited-default)",
            "link-visited-hover": "var(--color-link-visited-hover)",
            "link-visited-press": "var(--color-link-visited-press)",
            "icon-default": "var(--color-icon-default)",
            "icon-subtle": "var(--color-icon-subtle)",
            "icon-inverse": "var(--color-icon-inverse)",
            "icon-selected": "var(--color-icon-selected)",
            "icon-disabled": "var(--color-icon-disabled)",
            "icon-brand": "var(--color-icon-brand)",
            "icon-success": "var(--color-icon-success)",
            "icon-warning": "var(--color-icon-warning)",
            "icon-danger": "var(--color-icon-danger)",
            "icon-announcement": "var(--color-icon-announcement)",
            "icon-information": "var(--color-icon-information)",
            "icon-accent-red": "var(--color-icon-accent-red)",
            "icon-accent-orange": "var(--color-icon-accent-orange)",
            "icon-accent-yellow": "var(--color-icon-accent-yellow)",
            "icon-accent-green": "var(--color-icon-accent-green)",
            "icon-accent-magenta": "var(--color-icon-accent-magenta)",
            "icon-accent-teal": "var(--color-icon-accent-teal)",
            "accent-red": "var(--color-text-accent-red)",
            "accent-orange": "var(--color-text-accent-orange)",
            "accent-yellow": "var(--color-text-accent-yellow)",
            "accent-green": "var(--color-text-accent-green)",
            "accent-blue": "var(--color-text-accent-blue)",
            "accent-purple": "var(--color-text-accent-purple)",
            "accent-magenta": "var(--color-text-accent-magenta)",
            "accent-teal": "var(--color-text-accent-teal)",
            "accent-grey": "var(--color-text-accent-grey)",
            // start shadcn
            foreground: "hsl(var(--foreground))",
            // end shadcn
        },
        backgroundColor: backgroundColors,
        borderColor: {
            subtlest: "var(--color-border-subtlest)",
            subtle: "var(--color-border-subtle)",
            default: "var(--color-border-default)",
            focus: "var(--color-border-focus)",
            "brand-primary": "var(--color-border-brand-primary)",
            "brand-secondary": "var(--color-border-brand-secondary)",
            "input-default": "var(--color-border-input-default)",
            "input-selected": "var(--color-border-input-selected)",
            "input-disabled": "var(--color-border-input-disabled)",
            "success-subtle": "var(--color-border-success-subtle)",
            "success-default": "var(--color-border-success-default)",
            "success-bold": "var(--color-border-success-bold)",
            "warning-subtle": "var(--color-border-warning-subtle)",
            "warning-default": "var(--color-border-warning-default)",
            "warning-bold": "var(--color-border-warning-bold)",
            "danger-subtle": "var(--color-border-danger-subtle)",
            "danger-default": "var(--color-border-danger-default)",
            "danger-bold": "var(--color-border-danger-bold)",
            "announcement-subtle": "var(--color-border-announcement-subtle)",
            "announcement-default": "var(--color-border-announcement-default)",
            "announcement-bold": "var(--color-border-announcement-bold)",
            "information-subtle": "var(--color-border-information-subtle)",
            "information-default": "var(--color-border-information-default)",
            "information-bold": "var(--color-border-information-bold)",
            "accent-red": "var(--color-border-accent-red)",
            "accent-orange": "var(--color-border-accent-orange)",
            "accent-yellow": "var(--color-border-accent-yellow)",
            "accent-green": "var(--color-border-accent-green)",
            "accent-blue": "var(--color-border-accent-blue)",
            "accent-purple": "var(--color-border-accent-purple)",
            "accent-magenta": "var(--color-border-accent-magenta)",
            "accent-teal": "var(--color-border-accent-teal)",
            "accent-grey": "var(--color-border-accent-grey)",
            // start shadcn
            border: "hsl(var(--border))",
            // end shadcn
        },
        colors: {
            // All the colors that don't have a more specific role available in tailwind
            // start design system
            "data-categorical-1-default":
                "var(--color-data-categorical-1-default)",
            "data-categorical-1-hover": "var(--color-data-categorical-1-hover)",
            "documentation-text-default": "var(--documentation-text-default)",
            "documentation-border-subtlest":
                "var(--documentation-border-subtlest)",
            "documentation-border-subtle": "var(--documentation-border-subtle)",
            "documentation-border-default":
                "var(--documentation-border-default)",
            "documentation-text-subtle": "var(--documentation-text-subtle)",
            "icon-accent-grey": "var(--color-icon-accent-grey)",
            "icon-default": "var(--color-icon-default)",
            "icon-selected": "var(--color-icon-selected)",
            "data-categorical-2-default":
                "var(--color-data-categorical-2-default)",
            "data-categorical-2-hover": "var(--color-data-categorical-2-hover)",
            "data-categorical-2-area": "var(--color-data-categorical-2-area)",
            "data-categorical-3-default":
                "var(--color-data-categorical-3-default)",
            "data-categorical-3-hover": "var(--color-data-categorical-3-hover)",
            "data-categorical-3-area": "var(--color-data-categorical-3-area)",
            "data-categorical-4-default":
                "var(--color-data-categorical-4-default)",
            "data-categorical-4-hover": "var(--color-data-categorical-4-hover)",
            "data-categorical-4-area": "var(--color-data-categorical-4-area)",
            "data-categorical-5-default":
                "var(--color-data-categorical-5-default)",
            "data-categorical-5-hover": "var(--color-data-categorical-5-hover)",
            "data-categorical-5-area": "var(--color-data-categorical-5-area)",
            "data-categorical-6-default":
                "var(--color-data-categorical-6-default)",
            "data-categorical-6-hover": "var(--color-data-categorical-6-hover)",
            "data-categorical-6-area": "var(--color-data-categorical-6-area)",
            "data-categorical-7-default":
                "var(--color-data-categorical-7-default)",
            "data-categorical-7-hover": "var(--color-data-categorical-7-hover)",
            "data-categorical-7-area": "var(--color-data-categorical-7-area)",
            "data-categorical-8-default":
                "var(--color-data-categorical-8-default)",
            "data-categorical-8-hover": "var(--color-data-categorical-8-hover)",
            "data-categorical-8-area": "var(--color-data-categorical-8-area)",
            "data-neutral-default": "var(--color-data-neutral-default)",
            "data-brand-default": "var(--color-data-brand-default)",
            "data-brand-hover": "var(--color-data-brand-hover)",
            "data-brand-area": "var(--color-data-brand-area)",
            "data-neutral-hover": "var(--color-data-neutral-hover)",
            "data-neutral-area": "var(--color-data-neutral-area)",
            "data-success-default": "var(--color-data-success-default)",
            "data-success-hover": "var(--color-data-success-hover)",
            "data-success-area": "var(--color-data-success-area)",
            "data-warning-default": "var(--color-data-warning-default)",
            "data-warning-hover": "var(--color-data-warning-hover)",
            "data-warning-area": "var(--color-data-warning-area)",
            "data-danger-default": "var(--color-data-danger-default)",
            "data-danger-hover": "var(--color-data-danger-hover)",
            "data-danger-area": "var(--color-data-danger-area)",
            "data-announcement-default":
                "var(--color-data-announcement-default)",
            "data-announcement-hover": "var(--color-data-announcement-hover)",
            "data-announcement-area": "var(--color-data-announcement-area)",
            "data-information-default": "var(--color-data-information-default)",
            "data-information-hover": "var(--color-data-information-hover)",
            "data-information-area": "var(--color-data-information-area)",
            ring: "var(--color-border-focus)",
            "ring-danger": "var(--color-border-danger-default)",
            "ring-input-selected": "var(--color-border-input-selected)",
            scrollbar: "var(--color-background-neutral-bold-default)",
            "scrollbar-hover": "var(--color-background-neutral-bold-hover)",
            "scrollbar-pressed": "var(--color-background-neutral-bold-active)",
            // end design system
            // start shadcn
            card: {
                DEFAULT: "hsl(var(--card))",
                foreground: "hsl(var(--card-foreground))",
            },
            popover: {
                DEFAULT: "hsl(var(--popover))",
                foreground: "hsl(var(--popover-foreground))",
            },
            primary: {
                DEFAULT: "hsl(var(--primary))",
                foreground: "hsl(var(--primary-foreground))",
            },
            secondary: {
                DEFAULT: "hsl(var(--secondary))",
                foreground: "hsl(var(--secondary-foreground))",
            },
            muted: {
                DEFAULT: "hsl(var(--muted))",
                foreground: "hsl(var(--muted-foreground))",
            },
            accent: {
                DEFAULT: "hsl(var(--accent))",
                foreground: "hsl(var(--accent-foreground))",
            },
            destructive: {
                DEFAULT: "hsl(var(--destructive))",
                foreground: "hsl(var(--destructive-foreground))",
            },
            input: "hsl(var(--input))",
            chart: {
                1: "hsl(var(--chart-1))",
                2: "hsl(var(--chart-2))",
                3: "hsl(var(--chart-3))",
                4: "hsl(var(--chart-4))",
                5: "hsl(var(--chart-5))",
            },
            // end shadcn
        },
        // extends means that the following variables are added,
        // meaning that all existing tailwind classes are still available.
        extend: {
            padding: {
                default: "var(--padding-default)",
                narrower: "var(--padding-narrower)",
                narrow: "var(--padding-narrow)",
                wide: "var(--padding-wide)",
                wider: "var(--padding-wider)",
                widest: "var(--padding-widest)",
            },
            margin: {
                default: "var(--gap-default)",
                narrower: "var(--gap-narrower)",
                narrow: "var(--gap-narrow)",
                wide: "var(--gap-wide)",
                wider: "var(--gap-wider)",
                widest: "var(--gap-widest)",
            },
            gap: {
                default: "var(--gap-default)",
                narrower: "var(--gap-narrower)",
                narrow: "var(--gap-narrow)",
                wide: "var(--gap-wide)",
                wider: "var(--gap-wider)",
                widest: "var(--gap-widest)",
            },
            space: {
                default: "var(--gap-default)",
                narrower: "var(--gap-narrower)",
                narrow: "var(--gap-narrow)",
                wide: "var(--gap-wide)",
                wider: "var(--gap-wider)",
                widest: "var(--gap-widest)",
            },
            minHeight: {
                default: "var(--height-default)",
                compact: "var(--height-compact)",
                relaxed: "var(--height-relaxed)",
            },
            height: {
                default: "var(--height-default)",
                compact: "var(--height-compact)",
                relaxed: "var(--height-relaxed)",
            },
            boxShadow: {
                overlay:
                    "0px 8px 12px 0px var(--color-neutral-alpha-300a), 0px 0px 1px 0px var(--color-neutral-alpha-400a)",
            },
        },
    },
    plugins: [tailwindAnimate, tailwindScrollbar, tailwindTypography],
} satisfies Config;

export default config;
